import { firestore } from 'firebase';

export class UserDetails {
  public profileComplete: boolean;
  public firstName: string;
  public lastName: string;
  public phoneNumber: string;
  public emailAddress: string;
  public dateOfBirth: firestore.Timestamp;
  public isServiceProvider: boolean;
  public rsaCitizen: string;
  public rsaIdNumber: string;
  public passportNumber: string;
  public addressStreet1: string;
  public addressStreet2: string;
  public addressCity: string;
  public addressPostCode: string;
  // This refers to Google, Facebook, Yahoo, etc.
  public isNotThirdPartyAuth: boolean;

  displayName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  constructor(init?: Partial<UserDetails>) {
    Object.assign(this, init);
  }
}
